import { useEffect, useState } from 'react';
import api from '../services/api';
import SEO from '../components/SEO';

const VerifyEmailPage = ({ token, switchToLogin }) => {
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await api.post('/auth/verify-email', { token });
        setStatus('success');
        setMessage(res.data.message);
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Verification failed. The link may be invalid or expired.');
      }
    };
    if (token) verify();
    else {
        setStatus('error');
        setMessage('No verification token provided.');
    }
  }, [token]);

  return (
    <div className="auth-page">
      <SEO title="Verify Email" description="Verify your Study Centro account email address." />
      <div className="auth-card" style={{ textAlign: 'center' }}>
        {status === 'verifying' && (
          <>
            <h1>Verifying...</h1>
            <div className="spinner" style={{ margin: '20px auto' }}></div>
            <p>Please wait while we verify your email address.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <h1 style={{ color: 'var(--success)' }}>✓ Email Verified</h1>
            <p>{message}</p>
            <button onClick={switchToLogin} style={{ marginTop: '20px' }}>Go to Login</button>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 style={{ color: 'var(--danger)' }}>✗ Verification Failed</h1>
            <p>{message}</p>
            <button onClick={switchToLogin} className="secondary" style={{ marginTop: '20px' }}>Back to Login</button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
